import { contracts } from '../../data/contracts'

export default {
	name: 'WOOD',
	shortName: 'OWOOD',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].woodAddress,
	url: 'http://lorem.com',
	logo: 'tokens/OWood.png'
}
